import { ValueOf } from '../utilities/types';
import languages, { Languages } from './languages';

const controlTypes = {
  SHAREHOLDER: 'shareholder',
  VOTING_RIGHT: 'votingRight',
  AGREEMENT_MEMBERSHIP: 'agreementMembership',
  APPOINTMENT_RIGHT: 'appointmentRight',
  TRUSTEE: 'trustee',
  BOARD_MEMBER: 'boardMember',
  BENEFICIARY: 'beneficiary',
  SETTLOR: 'settlor',
  OTHER_COMPANIES: 'otherCompanies',
  OTHER: 'other',
} as const;

const controlTypeEnLabels = {
  [controlTypes.SHAREHOLDER]: 'Shareholder or partner',
  [controlTypes.VOTING_RIGHT]: 'Voting right',
  [controlTypes.AGREEMENT_MEMBERSHIP]: 'Agreement, articles of association, similar or membership',
  [controlTypes.APPOINTMENT_RIGHT]: 'Right to appoint and dismiss more than half of the board members, etc',
  [controlTypes.TRUSTEE]: 'Trustee in a foundation or trust',
  [controlTypes.BOARD_MEMBER]: 'Board member in a foundation',
  [controlTypes.BENEFICIARY]: 'Beneficiary in a foundation or trust',
  [controlTypes.SETTLOR]: 'Settlor in trust',
  [controlTypes.OTHER_COMPANIES]: 'Control through other companies',
  [controlTypes.OTHER]: 'Other',
} as const;

const controlTypeSvLabels = {
  [controlTypes.SHAREHOLDER]: 'Aktieägare eller andelsägare',
  [controlTypes.VOTING_RIGHT]: 'Rösträtt',
  [controlTypes.AGREEMENT_MEMBERSHIP]: 'Avtal, bolagsordning, liknande eller medlemskap',
  [controlTypes.APPOINTMENT_RIGHT]: 'Rätt att utse och avsätta mer än hälften av styrelseledamöterna etc',
  [controlTypes.TRUSTEE]: 'Förvaltare i stiftelse eller trust',
  [controlTypes.BOARD_MEMBER]: 'Styrelseledamot i stiftelse',
  [controlTypes.BENEFICIARY]: 'Förmånstagare i stiftelse eller trust',
  [controlTypes.SETTLOR]: 'Instiftare i trust',
  [controlTypes.OTHER_COMPANIES]: 'Kontroll genom andra bolag',
  [controlTypes.OTHER]: 'Annat',
} as const;

const controlTypeDeLabels = {
  [controlTypes.SHAREHOLDER]: 'Gesellschafter oder Anteilseigner',
  [controlTypes.VOTING_RIGHT]: 'Stimmrecht',
  [controlTypes.AGREEMENT_MEMBERSHIP]: 'Vereinbarung, Satzung, Ähnliches oder Mitgliedschaft',
  [controlTypes.APPOINTMENT_RIGHT]: 'Recht, mehr als die Hälfte der Vorstandsmitglieder zu bestellen oder abzuberufen usw.',
  [controlTypes.TRUSTEE]: 'Treuhänder in einer Stiftung oder einem Trust',
  [controlTypes.BOARD_MEMBER]: 'Vorstandsmitglied in einer Stiftung',
  [controlTypes.BENEFICIARY]: 'Begünstigter in einer Stiftung oder einem Trust',
  [controlTypes.SETTLOR]: 'Stifter eines Trusts',
  [controlTypes.OTHER_COMPANIES]: 'Kontrolle über andere Unternehmen',
  [controlTypes.OTHER]: 'Sonstiges',
} as const;

const controlTypeLabels = {
  [languages.EN]: controlTypeEnLabels,
  [languages.SV]: controlTypeSvLabels,
  [languages.DE]: controlTypeDeLabels,
} as const;

const directControlChoices = [
  controlTypes.SHAREHOLDER,
  controlTypes.VOTING_RIGHT,
  controlTypes.AGREEMENT_MEMBERSHIP,
  controlTypes.APPOINTMENT_RIGHT,
  controlTypes.TRUSTEE,
  controlTypes.BOARD_MEMBER,
  controlTypes.BENEFICIARY,
  controlTypes.SETTLOR,
  controlTypes.OTHER,
] as const;

const indirectControlChoices = [
  controlTypes.SHAREHOLDER,
  controlTypes.VOTING_RIGHT,
  controlTypes.AGREEMENT_MEMBERSHIP,
  controlTypes.APPOINTMENT_RIGHT,
  controlTypes.TRUSTEE,
  controlTypes.BOARD_MEMBER,
  controlTypes.BENEFICIARY,
  controlTypes.SETTLOR,
  controlTypes.OTHER_COMPANIES,
  controlTypes.OTHER,
] as const;

export const directControlTypeChoices = (
  language: Languages,
) => directControlChoices.map((section) => ({
  id: section,
  name: controlTypeLabels[language][section],
}));

export const indirectControlTypeChoices = (
  language: Languages,
) => indirectControlChoices.map((section) => ({
  id: section,
  name: controlTypeLabels[language][section],
}));

export type ControlTypes = ValueOf<typeof controlTypes>;

export default controlTypes;
